// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"st_wrapper__ALEfK","scrollMargin":"st_scrollMargin__uLVuD"};